import { GETPROJECTDETAILS_FAIL, GETPROJECTDETAILS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const getProjectDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETPROJECTDETAILS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETPROJECTDETAILS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getProjectDetailsReducer;
